import React, { useState, useEffect } from 'react';
import { annotationApi } from '../api/annotationApi';

interface MarkdownExportDialogProps {
  fileKey: string;
  frameId?: string;
  onClose: () => void;
}

const MarkdownExportDialog: React.FC<MarkdownExportDialogProps> = ({ fileKey, frameId, onClose }) => {
  const [markdown, setMarkdown] = useState('');
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    annotationApi
      .exportMarkdown(fileKey, frameId)
      .then(setMarkdown)
      .catch(() => setMarkdown('Failed to generate markdown.'))
      .finally(() => setLoading(false));
  }, [fileKey, frameId]);

  const handleCopy = () => {
    navigator.clipboard.writeText(markdown).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: '#fff',
          borderRadius: '8px',
          width: '700px',
          maxWidth: '90vw',
          maxHeight: '80vh',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '16px 20px',
            borderBottom: '1px solid #eee',
          }}
        >
          <h3 style={{ margin: 0 }}>Markdown Export</h3>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button
              onClick={handleCopy}
              style={{
                padding: '6px 14px',
                background: copied ? '#2ecc71' : '#4A90D9',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '13px',
              }}
            >
              {copied ? 'Copied!' : 'Copy'}
            </button>
            <button
              onClick={onClose}
              style={{
                padding: '6px 14px',
                background: '#fff',
                color: '#666',
                border: '1px solid #ddd',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '13px',
              }}
            >
              Close
            </button>
          </div>
        </div>
        <div style={{ flex: 1, overflow: 'auto', padding: '16px 20px' }}>
          {loading ? (
            <div style={{ color: '#888', textAlign: 'center', padding: '20px' }}>Generating...</div>
          ) : (
            <pre
              style={{
                background: '#f8f9fa',
                padding: '16px',
                borderRadius: '4px',
                fontSize: '13px',
                lineHeight: '1.5',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                margin: 0,
              }}
            >
              {markdown}
            </pre>
          )}
        </div>
      </div>
    </div>
  );
};

export default MarkdownExportDialog;
